import { SD } from "../../../../Contracts";
export function isValidEventState(eventState) {
    return Object.values(SD.EventState).indexOf(eventState) > -1;
}
export function isValidDateRange_from(from) {
    const d = new Date(from);
    return d instanceof Date && !isNaN(d);
}
export function isValidDateRange_timeRange(timeRange) {
    return Object.values(SD.TimeRange).indexOf(timeRange) > -1;
}
//# sourceMappingURL=index.js.map